module.exports = __webpack_public_path__ + "img/background.b52e53b4.png";